import * as wConsts from '../consts/website-consts';

const initState = {
  Loaded: false,
  BillingData: {
  },
  CreateOrder: {
    Loaded: false,
    Result: {
      Code: 500,
      Message: ""
    }
  },
  CheckOrder: {
    Loaded: false,
    Result: {
      Code: 500,
      Message: ""
    }
  },
  Boost: {
    Loaded: false,
    Result: {
      Code: 500, Message: ""
    }
  }
};

export const billingReducer = (state = initState, action) => {
  switch(action.type) {
    case wConsts.VXS_CREATEORDER_PENDING: {
      state = {...state, CreateOrder: {...state.CreateOrder, Loaded: false}}
      break;
    }
    case wConsts.VXS_CREATEORDER_REJECTED: {
      state = {...state, CreateOrder: {Result: action.payload, Loaded: true}}
      break;
    }
    case wConsts.VXS_CREATEORDER_FULLFILLED: {
      state = {...state, CreateOrder: {Result: action.payload, Loaded: true}}
      break;
    }
    case wConsts.VXS_CHECKORDER_PENDING: {
      state = {...state, CheckOrder: {...state.CheckOrder, Loaded: false}}
      break;
    }
    case wConsts.VXS_CHECKORDER_REJECTED: {
      state = {...state, CheckOrder: {Result: action.payload, Loaded: true}}
      break;
    }
    case wConsts.VXS_CHECKORDER_FULLFILLED: {
      state = {...state, CheckOrder: {Result: action.payload, Loaded: true}}
      break;
    }
    case wConsts.DEF_CHECKORDER_SUCCESS: {
      state = {...state, CheckOrder: {Result: action.payload, Loaded: true}}
      break;
    }
    case wConsts.DEF_CHECKORDER_FAILED: {
      state = {...state, CheckOrder: {Result: action.payload, Loaded: true}}
      break;
    }
    case wConsts.FETCH_BILLING_PENDING: {
      state = {...state, Loaded: false}
      break;
    }
    case wConsts.FETCH_BILLING_REJECTED: {
      state = {...state, Loaded: true, BillingData: action.payload};
      break;
    }
    case wConsts.FETCH_BILLING_FULLFILLED: {
      state = {...state, Loaded: true, BillingData: action.payload};
      break;
    }
  }
  return state;
}
